import React from "react";
import { FormattedMessage } from "react-intl";

function TableHead(props) {
  return (
    <thead className="thead-light">
    <tr>
      <th></th>
      <th
        className="sort"
        data-sort="id"
        scope="col"
        onClick={() => props.applySort( "id" )}
      >
        <FormattedMessage id="components.pages.clients.tickets.table.id"/>
      </th>
      <th
        className="sort"
        data-sort="created_at"
        scope="col"
        onClick={() => props.applySort( "created_at" )}
      >
        <FormattedMessage id="components.pages.clients.tickets.table.created_at"/>
      </th>
      <th
        className="sort"
        data-sort="status"
        scope="col"
        onClick={() => props.applySort( "status" )}
      >
        <FormattedMessage id="components.pages.clients.tickets.table.status"/>
      </th>
      <th
        className="sort"
        data-sort="organization_name"
        scope="col"
        onClick={() => props.applySort( "organization_name" )}
      >
        <FormattedMessage
          id="components.pages.clients.tickets.table.organization"/>
      </th>
      <th>
        <FormattedMessage id="components.pages.clients.tickets.table.user"/>
      </th>
      <th>
        <FormattedMessage id="components.pages.clients.tickets.table.email"/>
      </th>
      <th
        className="sort"
        data-sort="subject"
        scope="col"
        onClick={() => props.applySort( "subject" )}
      >
        <FormattedMessage id="components.pages.clients.tickets.table.subject"/>
      </th>
      <th
        className="sort"
        data-sort="type"
        scope="col"
        onClick={() => props.applySort( "type" )}
      >
        <FormattedMessage id="components.pages.clients.tickets.table.type"/>
      </th>
      <th scope="col">
        <FormattedMessage id="components.pages.clients.tickets.table.reason"/>
      </th>
      <th
        className="sort"
        data-sort="product_reference"
        scope="col"
        onClick={() => props.applySort( "product_reference" )}
      >
        <FormattedMessage id="components.pages.clients.tickets.table.product_reference"/>
      </th>
      <th scope="row" className="w-10">
        <FormattedMessage id="components.pages.clients.tickets.table.actions"/>
      </th>
    </tr>
    </thead>
  );
}

export { TableHead };
